import { mergeDeepRight } from "ramda";
import globalConfig from "../util/globalConfig";
import apiRoot from "./apiRoot";
var BASE_URL = apiRoot(window.location.hostname);
var retrieveJWT = function retrieveJWT(refresh) {
  return globalConfig.get("tokenProvider")(refresh)["catch"](function () {
    throw new Error("No JWT was provided");
  });
};
var authenticatedPayload = function authenticatedPayload(data, userJWT) {
  return mergeDeepRight(data, {
    headers: {
      Authorization: "Bearer ".concat(userJWT),
      Accept: "application/hal+json"
    }
  });
};
var unauthenticatedPayload = function unauthenticatedPayload(data) {
  return mergeDeepRight(data, {
    headers: {
      Accept: "application/hal+json"
    }
  });
};
var buildPayload = function buildPayload(data, userJWT) {
  if (userJWT) {
    return authenticatedPayload(data, userJWT);
  }
  return unauthenticatedPayload(data);
};
var fetchWithJWT = function fetchWithJWT(ref, data, userJWT) {
  var payload = buildPayload(data, userJWT);
  return fetch(ref, payload).then(function (response) {
    if (response.status > 199 && response.status < 300) {
      return response;
    }
    throw response;
  })
  // eslint-disable-next-line no-extra-parens
  .then(function (response) {
    return response.status === 204 ? {} : response.json();
  });
};
var retryIfUnauthorized = function retryIfUnauthorized(url, payload, data) {
  if (data.status === 401) {
    return retrieveJWT(true).then(function (userJWT) {
      return fetchWithJWT(url, payload, userJWT);
    });
  }
  throw data;
};
export var fetchResource = function fetchResource() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BASE_URL;
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return retrieveJWT().then(function (userJWT) {
    return fetchWithJWT(ref, data, userJWT);
  })["catch"](function (response) {
    return retryIfUnauthorized(ref, data, response);
  });
};
export var fetchResourceUnauthenticated = function fetchResourceUnauthenticated() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BASE_URL;
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetchWithJWT(ref, data);
};